
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fleet-inspection-software",
      function () {
        return require("private-next-pages/fleet-inspection-software.js");
      }
    ]);
  